import React from "react";
import { ThemeProvider } from "styled-components";
import { FAVICON } from "../../image-links";
import { PRODUCT_NAME } from "../../text";
import {
  starterTheme,
  FOOTER_COLOR,
  PRIMARY_COLOR,
  PRIMARY_FONT_TEXT,
  TITLE_FONT,
} from "../../theme";
import { SITE_URL } from "../../constants";
import { StyledFooter } from "./Footer.styles";

const Footer = () => {
  const links = [
    {
      to: `${SITE_URL}/contact`,
      title: "Contact Us",
      useFullInternalLink: true,
    },
    {
      to: `${SITE_URL}/privacy`,
      title: "Privacy Policy",
      useFullInternalLink: true,
    },
    {
      to: `${SITE_URL}/terms`,
      title: "Terms of Use",
      useFullInternalLink: true,
    },
    {
      to: `${SITE_URL}/cookie`,
      title: "Cookie Policy",
      useFullInternalLink: true,
    },
    {
      to: `${SITE_URL}/ccpa`,
      title: "CA Privacy Policy",
      useFullInternalLink: true,
    },
  ];

  const theme = {
    ...starterTheme,
    BodyText: `
        font-family: ${PRIMARY_FONT_TEXT};
        line-height: 33px;
        color: ${FOOTER_COLOR};
        text-align: left;
        letter-spacing: 0.68px;
        font-weight: 400;
        font-size: 0.8125rem;
        margin: 0;
        white-space: nowrap;
    `,
    Logo: `
      width: auto;
    `,
  };

  return (
    <ThemeProvider theme={theme}>
      <StyledFooter
        productName={PRODUCT_NAME}
        productLogo={FAVICON}
        textColor={FOOTER_COLOR}
        backgroundColor={PRIMARY_COLOR}
        links={links}
        font={TITLE_FONT}
      />
    </ThemeProvider>
  );
};

export default Footer;
